var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade show invalid-feedback",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [_vm._v("Edit tijdslot")]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                },
                on: { click: _vm.handleClose }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm.type === "individueel"
                ? _c("select-field", {
                    attrs: {
                      error: _vm.session.error,
                      name: "session",
                      options: _vm.sessions,
                      multiple: false,
                      clearable: false,
                      label: "Training"
                    },
                    model: {
                      value: _vm.session.value,
                      callback: function($$v) {
                        _vm.$set(_vm.session, "value", $$v)
                      },
                      expression: "session.value"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("time-field", {
                      attrs: {
                        error: _vm.start.error,
                        label: "Vanaf",
                        name: "start"
                      },
                      model: {
                        value: _vm.start.value,
                        callback: function($$v) {
                          _vm.$set(_vm.start, "value", $$v)
                        },
                        expression: "start.value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("time-field", {
                      attrs: {
                        error: _vm.end.error,
                        label: "Tot",
                        name: "end"
                      },
                      model: {
                        value: _vm.end.value,
                        callback: function($$v) {
                          _vm.$set(_vm.end, "value", $$v)
                        },
                        expression: "end.value"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger mr-auto",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.handleDelete()
                  }
                }
              },
              [_vm._v("Verwijderen")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleClose }
              },
              [_vm._v("Annuleren")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.handleSave()
                  }
                }
              },
              [_vm._v("Tijdslot opslaan")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Agenda/EditDate.vue?vue&type=template&id=8961c9d2&
// module id = 423
// module chunks = 0